import { ConversationTurnState } from '../../model/StatsAssistant'
import { IDLE_TURN_STATE } from './statsAssistant.atom'

export const patchTurn = (
  turns: Record<string, ConversationTurnState>,
  conversationUlid: string,
  patch: Partial<ConversationTurnState>,
): Record<string, ConversationTurnState> => ({
  ...turns,
  [conversationUlid]: { ...(turns[conversationUlid] ?? IDLE_TURN_STATE), ...patch },
})
